import DOMPurify from 'dompurify';

export const sanitizeHTML = (vulnerableDOMElement?: string) => {
  return vulnerableDOMElement ? DOMPurify.sanitize(vulnerableDOMElement) : '';
};
